import { parsePhoneNumberFromString } from 'libphonenumber-js';

export function normalizePhone(raw: string): { e164: string | null; last9: string | null } {
  const digits = (raw || '').replace(/\D/g, '');
  const last9 = digits.length >= 9 ? digits.slice(-9) : null;
  const parsed = parsePhoneNumberFromString(raw, 'IL');
  const e164 = parsed?.isValid() ? parsed.number : null;
  return { e164, last9 };
}
